<!-- <button
  pButton
  type="button"
  (click)="onClickHandler()"
  label="{{ label }}"
  class="ui-button-primary ui-widget ui-state-default ui-corner-all ui-button-text-only blueBackground"
  ></button> -->

<button
  mat-raised-button
  color="primary"
  type="{{type}}"
  disabled="{{ disabled ? true : false }}"
  (click)="onClickHandler()"
>{{ label }}</button>
